export { default as DemographicsAgeChart } from './components/Age';
export { default as DemographicsGenderChart } from './components/Gender';
export { default as DemographicsIncomeChart } from './components/Income';
